var RscpCfg;

(function () {
    /* globals CosmeticPage */

    //
    // this map reflects mapping from the configuration properties
    // as they exist now to a set of global variables that used to
    // contain the properties' values, we maintain the existence of
    // the globals for backwards compatibility with existing clients'
    // integrations... with the hope that eventually they get phased
    // out
    //
    var backwardsCompatibilityMap = {
            scormResultsPage: "SCORM_RESULTS_PAGE",
            aiccResultsPage: "AICC_RESULTS_PAGE",
            serverLoggerPage: "SERVER_LOGGER_PAGE",
            debugLogPersistPage: "DEBUG_LOG_PERSIST_PAGE",
            shouldSaveClientDebugLogs: "SHOULD_SAVE_CLIENT_DEBUG_LOGS",
            errorReportFormUrl: "ERROR_REPORT_FORM_URL",
            shouldPromptOnClose: "SHOULD_PROMPT_ON_CLOSE",
            preferSendBeacon: "PREFER_SEND_BEACON",
            clientDebuggerEnabled: "CLIENT_DEBUGGER_ENABLED",
            prerequisiteSkipBlocked: "PREREQUISITE_SKIP_BLOCKED",
            sspEnabled: "SSP_ENABLED",
            maxSspStorage: "MAX_SSP_STORAGE",
            scormImmediateSyncCommit: "SCORMImmediateSyncCommit",
            launchHistoryId: "LaunchHistoryId",
            querystringAdditions: "QuerystringAdditions",
            extCfg: "ExternalConfig",
            extRegId: "ExternalRegistrationId",
            pathToCourse: "PathToCourse",
            redirectOnExitUrl: "RedirectOnExitUrl",
            learnerName: "LearnerName",
            learnerId: "LearnerId",
            intermediatePage: "IntermediatePage",
            popupLauncherPage: "PopupLauncherPage",
            registrationToDeliver: "RegistrationToDeliver"
        },

        //
        // this map contains mapping from configuration values that can
        // be set to a function that takes the value being set and returns
        // the actual value we store in the configuration object (intended
        // such that the original source when a reference is not changed)
        //
        setFilterMap = {},

        // this map contains a list of the values found in the `topParams`
        // configuration setting that are booleans, needed because .NET
        // and Java differ in the case generated for the string values
        // representing the booleans
        topParamBooleans = {
            showFinish: true,
            showClose: true,
            showProgress: true,
            useMeasureProgress: true,
            showHelp: true,
            enableFlow: true,
            showNavBar: true,
            showTitleBar: true,
            showCourseStructure: true,
            preventRightClick: true
        };

    setFilterMap.topParams = function (orig) {
        var result = {},
            k;

        for (k in orig) {
            if (orig.hasOwnProperty(k)) {
                result[k] = orig[k];

                if (typeof topParamBooleans[k] !== "undefined") {
                    if (orig[k] === "True" || orig[k] === "true" || orig[k] === true) {
                        result[k] = true;
                    }
                    else {
                        result[k] = false;
                    }
                }
            }
        }

        return result;
    };

    setFilterMap.intermediatePage = setFilterMap.popupLauncherPage = function (orig) {
        if (typeof orig === CosmeticPage) {
            return orig;
        }

        return new CosmeticPage(orig.FrameName, orig.PageHref, orig.Parameters);
    };

    RscpCfg = function (cfg) {
        var prop;

        this._cfg = {
            version: null,
            learningStandard: null,
            is2004Enabled: null,
            scormResultsPage: null,
            aiccResultsPage: null,
            serverLoggerPage: null,
            debugLogPersistPage: null,
            shouldSaveClientDebugLogs: null,
            sendDebugLogsAsJson: null,
            errorReportFormUrl: null,
            shouldPromptOnClose: null,
            preferSendBeacon: null,
            clientDebuggerEnabled: null,
            prerequisiteSkipBlocked: null,
            sspEnabled: null,
            maxSspStorage: null,
            scormImmediateSyncCommit: null,
            launchHistoryId: null,
            querystringAdditions: null,
            resizeToWidth: null,
            resizeToHeight: null,
            moveToLeft: null,
            moveToTop: null,
            extCfg: null,
            extRegId: null,
            pathToCourse: null,
            redirectOnExitUrl: null,
            redirectOnRefreshUrl: null,
            learnerName: null,
            learnerId: null,
            intermediatePage: null,
            popupLauncherPage: null,
            helpPage: null,
            wrapScoWithApiPage: null,
            contentAuthCookies: null,
            registrationToDeliver: null,
            langDirection: null,
            clientCustomizationScript: null,
            clientCustomizationStylesheet: null,
            modernLogo: null,
            legacySupportFrames: null,
            legacyStylesheetUrl: null,
            headerAdditions: null,
            topParams: {},
            cmi5LaunchTemplate: null,
            cmi5Aus: null,
            isOffline: null,
            privacyPolicyUrl: null,
            intermediatePageLoadAtStart: null,
            mediaContentStylesheet: null,
            pdfContentStylesheet: null,
            audioVideoContentStylesheet: null,
            mediaContentCompletionThreshold: null,
            webContentForceNewWindow: null,
            pdfPageViewThreshold: null,
            dispatchStatusAuthoritativeSource: null,
            ltiLaunchTemplate: null,
            oidcLoginParams: null,
            compressRecordResultsPayload: null,
            rollupOnTerminate: null,
            useDeltaRecordResultsPayload: null,
            exitPlayerOnSingleScoClose: null,
            pdfContentScaling: null,
            audioVideoPlayer: null,
            seekForward: null,
            seekBackward: null,
            playbackRates: [],
            pdfDownloadButton: null,
            originTrialTokens: null
        };

        if (typeof cfg !== "undefined") {
            for (prop in cfg) {
                if (cfg.hasOwnProperty(prop)) {
                    this.set(prop, cfg[prop]);
                }
            }
        }
    };

    RscpCfg.prototype = {
        _cfg: null,

        get: function (key) {
            if (typeof this._cfg[key] === "undefined") {
                throw new Error("Unset RscpCfg property: " + key);
            }

            return this._cfg[key];
        },

        set: function (key, val) {
            if (typeof this._cfg[key] === "undefined") {
                //
                // this originally threw an exception when trying to set an unrecognized
                // setting, but that has consequences for offline where the player is
                // effectively static (not being upgraded with Engine upgrades) so to
                // reduce the potential for newly added settings to break offline this
                // is switched to just a warning
                //
                // eslint-disable-next-line no-console
                console.warn("Unrecognized RscpCfg property: " + key);

                return;
            }

            if (typeof setFilterMap[key] !== "undefined") {
                this._cfg[key] = setFilterMap[key].call(this, val);
            }
            else {
                this._cfg[key] = val;
            }

            this._syncForBackwardsCompatibility(key);
        },

        _syncForBackwardsCompatibility: function (key) {
            if (typeof backwardsCompatibilityMap[key] !== "undefined") {
                window[backwardsCompatibilityMap[key]] = this._cfg[key];
            }
        },

        toJSON: function () {
            return JSON.stringify(
                this._cfg,
                function (k, v) {
                    if (k === "registrationToDeliver") {
                        // eslint-disable-next-line no-undefined
                        return undefined;
                    }

                    return v;
                },
                2
            );
        }
    };
}());
